/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Templates_Insert_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Insert event template" |
*
* @param {Event_Templates_Insert_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_templates_insert_aria_label = /** @type {((inputs?: Event_Templates_Insert_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Templates_Insert_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inserer le modele d'evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignisvorlage einfügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci modello evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставить шаблон события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Insertar plantilla de evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("插入事件模板")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントテンプレートを挿入")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट टेम्पलेट डालें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Inserir modelo de evento")
	return /** @type {LocalizedString} */ ("Insert event template")
});